import React from 'react'
import './index.scss'
import { ICONS } from '@App/const/common'

const MatchRoad = ({ step }: any) => (
    <div className={`match-road step-${step}`}>
        <div className="progress-item">
            <img className="work-icon" src={ICONS.workDetails} />
            <p>Choose Work</p>
        </div>
        <div className="progress-item">
            <img className="review-icon" src={ICONS.review} />
            <p>Review & Submit</p>
        </div>
    </div>
)

export { MatchRoad as default }
